
import Modal from "../Layouts/Modal.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    Modal,
  },
  data() {
    return {
      toggleModal: false,
      args: { email: "", password: "" },
    };
  },
  computed: {
    ...mapGetters(["getUserInformation"]),
  },
  methods: {
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    modal() {
      this.toggleModal = true;
    },
    async login() {
      let res = await this.$store.dispatch("post", {
        endpoint: "/auth/login/",
        auth: false,
        payload: this.args,
      });
      if (res == 200 || 201) {
        localStorage.setItem("token", res.data.token);
        let userInfo = { ...res.data };
        this.$store.commit("set", {
          type: "userInformation",
          data: userInfo,
        });
        this.$store.commit("set", {
          type: "isLoggedIn",
          data: true,
        });
        this.$router.push(`/reader/profile/${this.getUserInformation.user.id}`);
        this.reset();
      }
    },
  },
};
